import { render, staticRenderFns } from "./OctTabItem.vue?vue&type=template&id=5a5e9db1&scoped=true&"
import script from "./OctTabItem.vue?vue&type=script&lang=js&"
export * from "./OctTabItem.vue?vue&type=script&lang=js&"
import style0 from "./OctTabItem.vue?vue&type=style&index=0&id=5a5e9db1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5e9db1",
  null
  
)

export default component.exports